{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified Korean-speaking clinical research professional before activating locale=ko in production.",
  "app": {
    "name": "OneVerse",
    "loading": "로딩 중...",
    "save": "저장",
    "cancel": "취소",
    "delete": "삭제",
    "confirm": "확인",
    "submit": "제출",
    "edit": "편집",
    "close": "닫기",
    "back": "뒤로",
    "next": "다음",
    "search": "검색",
    "filter": "필터",
    "export": "내보내기",
    "yes": "예",
    "no": "아니오",
    "required": "필수",
    "optional": "선택",
    "none": "없음",
    "unknown": "알 수 없음",
    "error": "오류가 발생했습니다. 다시 시도해 주세요.",
    "powered_by": "{{name}} 제공"
  },
  "nav": {
    "home": "홈",
    "dashboard": "대시보드",
    "submissions": "제출물",
    "studies": "연구",
    "sites": "사이트",
    "users": "사용자",
    "settings": "설정",
    "notifications": "알림",
    "admin": "관리",
    "help": "도움말",
    "sign_out": "로그아웃",
    "logout": "로그아웃",
    "expand_sidebar": "사이드바 펼치기",
    "collapse_sidebar": "사이드바 접기"
  },
  "auth": {
    "sign_in": "로그인",
    "sign_in_button": "로그인",
    "sign_out": "로그아웃",
    "email": "이메일",
    "email_placeholder": "이메일을 입력하세요",
    "password": "비밀번호",
    "password_placeholder": "비밀번호를 입력하세요",
    "forgot_password": "비밀번호를 잊으셨나요?",
    "reset_password": "비밀번호 재설정",
    "enter_reset_code": "재설정 코드 입력",
    "reset_code_instructions": "이메일 주소를 입력하시면 비밀번호 재설정 코드를 보내드립니다.",
    "new_code_instructions": "코드와 새 비밀번호를 입력하세요.",
    "send_reset_code": "재설정 코드 보내기",
    "sending": "전송 중...",
    "reset_password_action": "비밀번호 재설정",
    "resetting": "재설정 중...",
    "create_account": "계정 만들기",
    "welcome": "OneVerse에 오신 것을 환영합니다",
    "remember_password": "비밀번호가 기억나시나요?",
    "confirmation_code": "확인 코드",
    "confirmation_code_placeholder": "이메일 또는 문자로 받은 코드를 입력하세요",
    "new_password": "새 비밀번호",
    "new_password_placeholder": "새 비밀번호를 입력하세요",
    "confirm_password": "새 비밀번호 확인",
    "confirm_password_placeholder": "새 비밀번호를 다시 입력하세요",
    "mfa": {
      "code": "코드",
      "back_to_login": "로그인으로 돌아가기",
      "sms_placeholder": "휴대폰으로 전송된 코드를 입력하세요",
      "email_placeholder": "이메일로 전송된 코드를 입력하세요",
      "totp_placeholder": "인증 앱의 코드를 입력하세요"
    },
    "show_password": "비밀번호 표시",
    "hide_password": "비밀번호 숨기기",
    "errors": {
      "invalid_credentials": "이메일 또는 비밀번호가 올바르지 않습니다.",
      "account_locked": "계정이 잠겼습니다. 지원팀에 문의하세요.",
      "session_expired": "세션이 만료되었습니다. 다시 로그인하세요.",
      "email_required": "이메일은 필수입니다",
      "email_password_required": "이메일과 비밀번호는 필수입니다",
      "all_fields_required": "모든 필드를 입력해 주세요",
      "passwords_dont_match": "비밀번호가 일치하지 않습니다",
      "unexpected": "예기치 않은 오류가 발생했습니다",
      "server_non_json": "서버가 JSON이 아닌 응답을 반환했습니다. 콘솔을 확인하세요."
    },
    "welcome_back": "다시 오셨군요",
    "subtitle": "세부 정보를 입력하세요.",
    "no_account": "계정이 없으신가요?",
    "sign_up": "가입"
  },
  "dashboard": {
    "welcome": "환영합니다, {{name}}님",
    "new_submission": "새 제출",
    "submission_overview": "제출 개요",
    "view_all_submissions": "모든 제출 보기",
    "recent_activity": "최근 활동",
    "no_recent_activities": "최근 활동이 없습니다.",
    "search_placeholder": "검색",
    "total": "합계",
    "submission_singular": "건의 제출",
    "submission_plural": "건의 제출",
    "active_site_status": "활성 사이트 현황",
    "view_study": "연구 보기",
    "loading_studies": "연구 로딩 중...",
    "select_study": "연구 선택",
    "view_details": "상세 보기",
    "news_and_notes": "뉴스 및 노트",
    "no_recent_posts": "최근 게시물이 없습니다.",
    "failed_to_load_announcements": "공지사항 로딩 실패",
    "statuses": {
      "response_required": "응답 필요",
      "drafts": "초안",
      "submitted": "제출됨",
      "pre_review": "사전 검토",
      "irb_review": "IRB 검토",
      "post_review": "검토 후 처리",
      "expiring_soon": "곧 만료"
    }
  },
  "submissions": {
    "title": "제출 목록",
    "new": "새 제출",
    "empty": "제출물이 없습니다.",
    "status": {
      "pending": "대기 중",
      "under_review": "검토 중",
      "approved": "승인됨",
      "rejected": "거부됨",
      "revisions_required": "수정 필요",
      "withdrawn": "철회됨",
      "expired": "만료됨",
      "closed": "종료됨",
      "draft": "초안",
      "submitted": "제출됨",
      "pre_review": "사전 검토",
      "irb_review": "IRB 검토",
      "post_review": "검토 후 처리",
      "response_required": "응답 필요",
      "expiring_soon": "곧 만료",
      "complete": "완료",
      "deleted": "삭제됨"
    },
    "fields": {
      "title": "제목",
      "protocol_number": "프로토콜 번호",
      "principal_investigator": "주요 연구자",
      "submitted_at": "제출일",
      "updated_at": "최종 수정일",
      "status": "상태",
      "type": "유형",
      "id": "ID",
      "submitted": "제출일",
      "expiration": "만료일"
    },
    "actions": {
      "view": "제출물 보기",
      "edit": "제출물 편집",
      "withdraw": "철회",
      "submit": "검토를 위해 제출"
    },
    "empty_yet": "아직 제출이 없습니다.",
    "search_placeholder": "ID 또는 제목으로 검색",
    "filter": {
      "all_statuses": "모든 상태",
      "all_types": "모든 유형",
      "status_label": "상태",
      "type_label": "유형"
    },
    "errors": {
      "failed_to_load": "제출 로드 실패"
    }
  },
  "studies": {
    "title": "연구 목록",
    "new": "새 연구",
    "empty": "연구가 없습니다.",
    "fields": {
      "title": "연구 제목",
      "irb_number": "IRB 번호",
      "pi": "주요 연구자",
      "status": "상태",
      "start_date": "시작일",
      "end_date": "종료일",
      "id": "ID",
      "type": "유형",
      "submitted": "제출일",
      "expiration": "만료일"
    },
    "empty_yet": "아직 연구가 없습니다.",
    "search_placeholder": "ID 또는 제목으로 검색",
    "filter": {
      "all_statuses": "모든 상태",
      "all_types": "모든 유형",
      "type_label": "유형",
      "attribute_label": "속성",
      "all_attributes": "모든 속성",
      "attribute_value_placeholder": "속성 값"
    },
    "errors": {
      "failed_to_load": "연구 로드 실패"
    },
    "standalone": "독립형",
    "sort_by": "{{column}}(으)로 정렬",
    "attributes": {
      "cro": "CRO",
      "sponsor": "스폰서",
      "pi": "PI",
      "pi_email": "PI 이메일",
      "poc": "POC",
      "poc_email": "POC 이메일",
      "poc_phone": "POC 전화번호",
      "poc_role": "POC 역할"
    }
  },
  "sites": {
    "title": "사이트 목록",
    "new": "새 사이트",
    "empty": "사이트가 없습니다.",
    "empty_yet": "아직 기관이 없습니다.",
    "search_placeholder": "ID, 기관명 또는 PI로 검색",
    "filter": {
      "all_statuses": "모든 상태",
      "all_countries": "모든 국가",
      "country_label": "국가"
    },
    "errors": {
      "failed_to_load": "기관 로드 실패"
    },
    "fields": {
      "id": "ID",
      "site_name": "기관명",
      "country": "국가",
      "protocol_number": "프로토콜 번호",
      "sponsor_name": "스폰서 이름",
      "pi_name": "PI 이름",
      "approved": "승인됨",
      "expiration": "만료일",
      "status": "상태"
    }
  },
  "errors": {
    "not_found": "요청한 리소스를 찾을 수 없습니다.",
    "unauthorized": "이 작업을 수행할 권한이 없습니다.",
    "server_error": "서버 오류가 발생했습니다. 나중에 다시 시도하세요.",
    "network_error": "네트워크 오류가 발생했습니다. 연결을 확인하세요.",
    "not_found_title": "페이지를 찾을 수 없습니다",
    "not_found_body": "찾으시는 페이지가 존재하지 않거나 이동되었습니다.",
    "go_back": "뒤로 가기"
  },
  "pagination": {
    "previous": "이전",
    "next": "다음",
    "page": "{{total}}페이지 중 {{current}}페이지",
    "showing": "{{total}}개 중 {{from}}–{{to}}개 표시"
  },
  "dates": {
    "today": "오늘",
    "yesterday": "어제",
    "just_now": "방금",
    "ago": "{{time}} 전"
  },
  "entity": {
    "status": {
      "in_progress": "진행 중",
      "active": "활성",
      "rejected": "거부됨",
      "suspended": "일시 중단됨",
      "closed": "종료됨",
      "expired": "만료됨"
    }
  },
  "activities": {
    "submission_approved": "제출 승인됨",
    "submission_created": "제출 생성됨",
    "submission_submitted": "제출됨",
    "submission_updated": "제출 업데이트됨",
    "submission_withdrawn": "제출 취소됨",
    "submission_rejected": "제출 거부됨",
    "submission_expired": "제출 만료됨",
    "study_created": "연구 생성됨",
    "study_updated": "연구 업데이트됨",
    "site_created": "기관 생성됨",
    "site_updated": "기관 업데이트됨",
    "status_changed": "상태 변경됨",
    "review_started": "검토 시작됨",
    "review_completed": "검토 완료",
    "comment_added": "댓글 추가됨",
    "document_uploaded": "문서 업로드됨",
    "response_required": "응답 필요"
  }
}
